import utils from '../../../components/Organisms/Form/utils'
import t from '../../../translations/main'

const config = utils.injectTranslation({
  id: 'Example',
  path: 'onboarding.forms.Example.inputs',
  content: [
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: 'repeat(2, 1fr)',
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'companyFullName',
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'registeredAddress',
            required: true,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: 'repeat(4, 1fr)',
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'registrationNo',
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'tradingName',
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'city',
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'postCode',
            required: true,
          },
        },
        {
          componentType: 'test',
          props: { headline: 'Another headline' },
        },
      ],
    },
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'radioGroup',
          transformType: 'stringToNumOrViceVersa',
          props: {
            name: 'shareholderType',
            dataList: [
              {
                id: 'shareholderType1',
                label: t('components.forms.labels.yes'),
                value: '1',
              },
              {
                id: 'shareholderType2',
                label: t('components.forms.labels.no'),
                value: '0',
              },
            ],
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: 'repeat(2, 1fr)',
      },
      content: [
        {
          componentType: 'dropdown',
          props: {
            name: 'dropdownTest',
          },
        },
        {
          componentType: 'date',
          transformType: 'date',
          props: {
            name: 'birthdayDate',
            birthday: true,
          },
        },
      ],
    },
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'inputMultipleNumbers',
          props: {
            name: 'giinNo',
            numberFormat: '000000-00000-00-000',
            // required: true
          },
        },
      ],
    },
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'input',
          props: {
            name: 'sourceOfFunds',
            isTextarea: true,
          },
        },
      ],
    },
  ],
})

export default config
